"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostTextGameplay = void 0;
const react_1 = __importStar(require("react"));
const gameplay_components_1 = require("../../gameplay_components");
const useHowl_1 = __importStar(require("../../hooks/useHowl"));
const asset_key_generator_1 = require("../../asset_key_generator");
const types_1 = require("../types");
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
function HostTextGameplay({ props }) {
    const { initiate, state, play, stop, error, reset: resetHowl, } = (0, useHowl_1.default)({
        onEnd() {
            handleAudioEnd();
        },
    });
    // hooks
    (0, react_1.useEffect)(() => {
        if (state === useHowl_1.UseHowlState.hasLoaded) {
            play();
        }
    }, [state]);
    (0, react_1.useEffect)(() => {
        if (error) {
            resetHowl();
            if (props.onFinishCard) {
                props.onFinishCard(props.card);
            }
        }
    }, [error, props.onFinishCard, props.card]);
    (0, react_1.useEffect)(() => {
        switch (props.gameplayControl) {
            case types_1.GameplayControl.PresentQuestion:
                if (props.onPresentQuestion) {
                    props.onPresentQuestion(props.card);
                }
                break;
            case types_1.GameplayControl.Pending:
                break;
            case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
            case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
                if (props.onPresentAnswer) {
                    props.onPresentAnswer(props.card);
                }
                break;
        }
    }, [
        props.gameplayControl,
        props.onPresentQuestion,
        props.onPresentAnswer,
        props.card,
    ]);
    (0, react_1.useEffect)(() => {
        switch (props.gameplayControl) {
            case types_1.GameplayControl.PresentQuestion:
                if (props.card.cardQuestion.questionAudios.length > 0) {
                    const urls = [];
                    for (const audio of props.card.cardQuestion.questionAudios) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    initiate(urls);
                }
                else if (props.card.cardQuestion.audioChoices.length > 0) {
                    const urls = [];
                    for (const audio of props.card.cardQuestion.audioChoices) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    initiate(urls);
                }
                break;
            case types_1.GameplayControl.Pending:
                stop();
                break;
            case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
            case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
                {
                    stop();
                    const urls = [];
                    for (const audio of props.card.cardQuestion.postAnswerAudios) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    if (props.card.cardQuestion.postAnswerAudios.length > 0 &&
                        urls.length === props.card.cardQuestion.postAnswerAudios.length) {
                        initiate(urls);
                    }
                    else {
                        setTimeout(() => {
                            resetHowl();
                            if (props.onFinishCard) {
                                props.onFinishCard(props.card);
                            }
                        }, props.wrongAnswerDisplayTime * 1000);
                    }
                }
                break;
            default:
                break;
        }
    }, [
        props.gameplayControl,
        props.card,
        props.fileUrls,
        props.card.cardQuestion.questionAudios,
        props.card.gameplayInfo.alwaysPlayPostAnswerAudios,
        props.card.cardQuestion.postAnswerAudios,
        props.rightAnswerDisplayTime,
        props.wrongAnswerDisplayTime,
    ]);
    const handleAudioEnd = (0, react_1.useCallback)(async () => {
        if (props.gameplayControl ===
            types_1.GameplayControl.PresentAnswerWithCorrectResponse ||
            props.gameplayControl ===
                types_1.GameplayControl.PresentAnswerWithIncorrectResponse) {
            await new Promise(res => setTimeout(res, props.wrongAnswerDisplayTime * 1000));
            resetHowl();
            if (props.onFinishCard) {
                props.onFinishCard(props.card);
            }
        }
    }, [props.gameplayControl]);
    function getQuestionComponent() {
        var _a, _b, _c;
        const answerControls = [
            types_1.GameplayControl.PresentAnswerWithCorrectResponse,
            types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
        ];
        return (react_1.default.createElement("div", { className: "flex justify-center items-center h-[232px] sm:h-[282px]" },
            react_1.default.createElement("div", { className: "flex flex-col gap-[16px] sm:gap-[24px]" },
                react_1.default.createElement(gameplay_components_1.FillInTheBlank, { text: (_b = (_a = props.card.cardQuestion.questionBottom) !== null && _a !== void 0 ? _a : props.card.cardQuestion.questionText) !== null && _b !== void 0 ? _b : '', inputs: answerControls.includes(props.gameplayControl)
                        ? props.card.cardAnswer.answerTexts
                        : [], activeInputIndex: 0, expectedInputs: props.card.cardAnswer.answerTexts, displayMode: 'UNDERSCORE', inputMode: 'FULL_TEXT', gameplayControl: answerControls.includes(props.gameplayControl)
                        ? types_1.GameplayControl.PresentAnswerWithCorrectResponse
                        : props.gameplayControl, gameplayStyle: props.gameplayStyle, onInteract: () => {
                        if (props.gameplayControl === types_1.GameplayControl.PresentQuestion) {
                            stop();
                            play();
                        }
                    }, onInteractNonBlank: () => {
                        if (props.gameplayControl === types_1.GameplayControl.PresentQuestion) {
                            stop();
                            play();
                        }
                    } }),
                react_1.default.createElement(gameplay_components_1.AttributedTypography, { variant: "h6", fontFamily: 'Bryant', fontStyle: 'normal', fontWeight: 700, lineHeight: '24px', letterSpacing: '0.15px', color: props.gameplayStyle === types_1.GameplayStyle.PopStudy
                        ? '#00000066'
                        : 'white', style: {
                        textAlign: 'center',
                        opacity: answerControls.includes(props.gameplayControl) ? 1 : 0,
                    } }, (_c = props.card.cardQuestion.translation) !== null && _c !== void 0 ? _c : ''))));
    }
    function getChoiceComponent() {
        return (react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement(gameplay_components_1.HostViewScoreboard, { choiceStats: props.choiceStats })));
    }
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(props.gameplayStyle) },
        react_1.default.createElement("div", { className: "px-[16px] lg:px-[134px] pb-[24px] w-full" },
            getQuestionComponent(),
            react_1.default.createElement("div", { className: "h-[16px] sm:h-[24px]" }),
            getChoiceComponent())));
}
exports.HostTextGameplay = HostTextGameplay;
